// extracted by mini-css-extract-plugin
module.exports = {"item":"SignUpRadio_item__30sNN","selected":"SignUpRadio_selected__6HxXc","title":"SignUpRadio_title__3knVf","description":"SignUpRadio_description__2W9io"};